import api from "./api";
import { config } from "./config.service";

const API_URL = config.host_api;

export const createComment = (data) => {
  return api.post(API_URL + "comment", data);
};

export const getComments = (report_id) => {
  return api
    .get(`${API_URL}comment/${report_id}`)
    .then((res) => {
      if (res.data) return res.data;
    })
    .catch((err) => err);
};

export const getCommentsByUserId = (user_id) => {
  return api
    .get(`${API_URL}comments/${user_id}`)
    .then((res) => {
      if (res.data) return res.data;
    })
    .catch((err) => err);
};
